import React from "react";
import {
  ReferenceInput,
  SelectInput,
  FormDataConsumer,
  required
} from "react-admin";

const SeasonCodeInput = () => (
  <FormDataConsumer>
    {({ formData, ...rest }) =>
      formData.sportCode && (
        <ReferenceInput
          label="Season"
          source="seasonCode"
          reference="availableSeasons"
          filter={{
            sportCode: formData.sportCode
          }}
        >
          <SelectInput
            optionText="label"
            optionValue="code"
            validate={[required()]}
          />
        </ReferenceInput>
      )
    }
  </FormDataConsumer>
);

export default SeasonCodeInput;
